export default __webpack_public_path__ + "static/media/logo2.b5d9020e.png";